import type { StateCreator } from 'zustand';
import type { Store } from '../types';

export function createHighlightActions(
  set: Parameters<StateCreator<Store>>[0],
  get: Parameters<StateCreator<Store>>[1],
) {
  return {
    // Toggle individual highlight visibility
    toggleHighlightVisible(type: keyof Store['highlights']['visible']) {
      set((state) => ({
        highlights: {
          ...state.highlights,
          visible: {
            ...state.highlights.visible,
            [type]: !state.highlights.visible[type],
          },
        },
      }));
    },

    // Set all highlight visibility
    setHighlightVisible(visible: Partial<Store['highlights']['visible']>) {
      set((state) => ({
        highlights: {
          ...state.highlights,
          visible: {
            ...state.highlights.visible,
            ...visible,
          },
        },
      }));
    },

    // Check if a highlight type is visible
    isHighlightVisible(type: keyof Store['highlights']['visible']): boolean {
      return get().highlights.visible[type];
    },
  };
}
